import { render, staticRenderFns } from "./avaliar-arboturma.vue?vue&type=template&id=43e67cf8&"
import script from "./avaliar-arboturma.vue?vue&type=script&lang=js&"
export * from "./avaliar-arboturma.vue?vue&type=script&lang=js&"
import style0 from "./avaliar-arboturma.vue?vue&type=style&index=0&lang=css&"
import style1 from "./avaliar-arboturma.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports